import { SET_SO_DISPLAY_ID, SET_SO_CUSTOMER_ID, SET_SO_PRODUCTS, SET_SO_PAYMENT_INFO, SET_NEW_SO_INFO, CLEAR_NEW_SO } from 'redux/actionTypes';

const initialState = {
    displayId: "",
    customerId: 0,
    soProducts: [],
    totalVat: 0,
    total: 0,
    paymentMethod: ""
};

export default function newSalesOrder(state = initialState, action) {
    switch(action.type) {
        case SET_SO_DISPLAY_ID:
            return {
                ...state,
                displayId: action.payload
            };
        case SET_SO_CUSTOMER_ID:
            return {
                ...state,
                customerId: action.payload
            };
        case SET_SO_PRODUCTS:
            return {
                ...state,
                soProducts: action.payload
            };
        case SET_SO_PAYMENT_INFO:
            return {
                ...state,
                totalVat: action.payload.totalVat,
                total: action.payload.total,
                paymentMethod: action.payload.paymentMethod
            };
        case SET_NEW_SO_INFO:
            return {
                displayId: action.payload.displayId,
                customerId: action.payload.customerId,
                soProducts: action.payload.soProducts,
                totalVat: action.payload.totalVat,
                total: action.payload.total,
                paymentMethod: action.payload.paymentMethod
            };
        case CLEAR_NEW_SO:
            return {
                displayId: "",
                customerId: 0,
                soProducts: [],
                totalVat: 0,
                total: 0,
                paymentMethod: ""
            };
        default:
            return state;
    }
};